/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Delete_TitleInputs */

const en_admin_categories_delete_title = /** @type {(inputs: Admin_Categories_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Category`)
};

const zh_admin_categories_delete_title = /** @type {(inputs: Admin_Categories_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除分类`)
};

/**
* | output |
* | --- |
* | "Delete Category" |
*
* @param {Admin_Categories_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_delete_title = /** @type {((inputs?: Admin_Categories_Delete_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Delete_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_delete_title(inputs)
	return zh_admin_categories_delete_title(inputs)
});
export { admin_categories_delete_title as "admin.categories.delete_title" }